import { Card, CardHeader, Title3, Body1, makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: '24px',
  },
  card: {
    maxWidth: '480px',
    width: '100%',
    padding: '32px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '24px',
  },
  logo: {
    fontSize: '48px',
    marginBottom: '12px',
  },
  description: {
    color: tokens.colorNeutralForeground3,
    marginTop: '8px',
    textAlign: 'center',
    display: 'block',
  },
  instructions: {
    color: tokens.colorNeutralForeground3,
    fontSize: '12px',
    lineHeight: '1.5',
    marginTop: '24px',
    padding: '12px',
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: '8px',
  },
})

export function Setup() {
  const styles = useStyles()

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <CardHeader
          header={
            <div className={styles.header}>
              <div className={styles.logo}>🔧</div>
              <Title3>Assist Engine Setup</Title3>
              <Body1 className={styles.description}>
                Automatic Teams SSO connection could not be established.
              </Body1>
            </div>
          }
        />

        <div className={styles.instructions}>
          Contact your IT administrator. This app requires a configured Microsoft Teams SSO
          connection and does not accept browser API keys.
        </div>
      </Card>
    </div>
  )
}
